export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  let len = Math.min(arr1.length, arr2.length)
  let i = -1
  let res = []
  while (++i < len) {
    const item = arr2[i]
    if (arr1.indexOf(item) > -1) res.push(item)
  }
  return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
  const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
  return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
  const d = new Date(timeStamp * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = '' //+ ':' + second
  if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
  else resStr = month + '-' + date + ' ' + hours + ':' + minutes
  return resStr
}
export const getYear = (d, startType) => {
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = '' //+ ':' + second
  if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
  else resStr = month + '-' + date + ' ' + hours + ':' + minutes
  return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
  // 判断当前传入的时间戳是秒格式还是毫秒
  const IS_MILLISECOND = isMillisecond(timeStamp)
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp)
  // 获取当前时间时间戳
  const currentTime = Math.floor(Date.parse(new Date()) / 1000)
  // 判断传入时间戳是否早于当前时间戳
  const IS_EARLY = isEarly(timeStamp, currentTime)
  // 获取两个时间戳差值
  let diff = currentTime - timeStamp
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff
  let resStr = ''
  const dirStr = IS_EARLY ? '前' : '后'
  // 少于等于59秒
  if (diff <= 59) resStr = diff + '秒' + dirStr
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + '分钟' + dirStr
  // 多于59分钟59秒，少于等于23小时59分钟59秒
  else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + '小时' + dirStr
  // 多于23小时59分钟59秒，少于等于29天59分钟59秒
  else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + '天' + dirStr
  // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
  else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp)
  else resStr = getDate(timeStamp, 'year')
  return resStr
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) return 'IE'
  else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function() {
  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function() {
  if (document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) return key in obj
  else {
    let keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}

export const xuankeshow = (obj1, type) => {
  let str = "";
  if (type == -1) {
    obj1.split(",").forEach(function(item){
      str+=xuanke(item)+",";
    })
  }
  return str.substring(0,str.length-1);
}
export const xuanke = (obj1) => {
  let str = ""
  switch (obj1) {
    case 'wl':
      str = "物理";
      break;
    case 'ls':
      str = "历史";
      break;
    case 'hx':
      str = "化学";
      break;
    case 'sw':
      str = "生物";
      break;
    case 'dl':
      str = "地理";
      break;
    case 'zz':
      str = "政治";
      break;
    case 'xxjs':
      str = "信息技术";
      break;
  }
  return str;
}
export const getJobType = (type) => {
  let list = {
    "02": {
      "code": '02',
      "name": '技术工程师',
      "children": {
        '0201': '科学家',
        '0202': '工程师',
        '0203': '兽医/园艺师/农技师',
        '0204': '飞行员/领航员',
        '0205': '医生/护士',
        '0206': '会计/审计',
        '0207': '银行/证券/投资',
        '0208': '律师/法官/法医',
        '0209': '教师',
        '0210': '艺术家/设计师/摄影师',
        '0211': '运动员/教练/裁判',
        '0213': '牧师/神职',
        '0212': '记者/编辑/主持人/翻译',
      },
    },
    "03": {
      "code": '03',
      "name": '公务员',
      "children": {
        '0301': '行政/秘书',
        '0302': '警察/消防员/保安',
        '0303': '邮递员/话务员/快递',
      }
    },
    "04": {
      "code": '04',
      "name": '服务员',
      "children": {
        '0401': '营业员/采购员',
        '0402': '保管员',
        '0403': '厨师/营养师',
        '0404': '导游/按摩师/服务员',
        '0405': '空姐/乘务员',
        '0406': '卫生防疫员',
        '0407': '美容美发师/维修工',
      }
    },
    "05": {
      "code": '05',
      "name": '农民',
      "children": {
        '0501': '园艺工',
        '0502': '护林员/野生动物保护员',
        '0503': '饲养工/动物检疫员',
        '0504': '养殖工',
        '0505': '水利工',
      }
    },
    "06": {
      "code": '06',
      "name": '工人',
      "children": {
        '0601': '勘测员',
        '0602': '冶金工',
        '0603': '化工',
        '0604': '车床工',
        '0605': '装配工',
        '0606': '维修师',
        '0607': '电工',
        '0608': '电子技工',
        '0609': '磨具工',
        '0610': '纺织工',
        '0611': '裁缝',
        '0612': '食品工',
        '0613': '烟草员',
        '0614': '药品技工',
        '0615': '木工',
        '0616': '造纸技工',
        '0617': '建筑工',
        '0618': '陶艺工',
        '0619': '视频剪辑师',
        '0620': '印刷工',
        '0621': '艺术工',
        '0622': '文具工',
        '0623': '工程技工',
        '0624': '驾驶员',
        '0625': '监测工',
        '0626': '检验工',
      }
    },
    "07": {
      "code": '07',
      "name": '军人',
      "children": {
        '0700': '军人',
      },
    },
    "互联网/IT": {
      "code": '互联网/IT',
      "name": '互联网/IT',
      "children": {
        '计算机软件': '计算机软件',
        '网络·电子商务': '网络·电子商务',
        '计算机硬件': '计算机硬件',
      },
    },
    "交通/运输/物流": {
      "code": '交通/运输/物流',
      "name": '交通/运输/物流',
      "children": {
        '运输': '运输',
        '交通': '交通',
        '物流仓储': '物流仓储',
      },
    },
    "其他": {
      "code": '其他',
      "name": '其他',
      "children": {
        '其他': '其他',
      },
    },
    "农/林/牧/渔/水利": {
      "code": '农/林/牧/渔/水利',
      "name": '农/林/牧/渔/水利',
      "children": {
        '牧业': '牧业',
        '水利': '水利',
        '农业': '农业',
        '渔业': '渔业',
        '园林业': '园林业',
      },
    },
    "制造业": {
      "code": '制造业',
      "name": '制造业',
      "children": {
        '汽车及零配件': '汽车及零配件',
        '原材料及加工': '原材料及加工',
        '机械·设备·重工·机电': '机械·设备·重工·机电',
        '汽车及零配件': '汽车及零配件',
        '汽车及零配件': '汽车及零配件',
        '汽车及零配件': '汽车及零配件',
      },
    },
    "咨询/专业服务": {
      "code": '咨询/专业服务',
      "name": '咨询/专业服务',
      "children": {
        '法律': '法律',
        '咨询': '咨询',
        '财会·审计': '财会·审计',
      },
    },
    "广告/公关": {
      "code": '广告/公关',
      "name": '广告/公关',
      "children": {
        '广告': '广告',
        '公关': '公关',
        '市场': '市场',
      },
    },
    "房地产/建筑": {
      "code": '房地产/建筑',
      "name": '房地产/建筑',
      "children": {
        '装饰装潢': '装饰装潢',
        '家具室内设计': '家具室内设计',
        '房地产': '房地产',
        '建筑': '建筑',

      },
    },
    "政府/非营利机构": {
      "code": '政府/非营利机构',
      "name": '政府/非营利机构',
      "children": {
        '政府': '政府',

      },
    },
    "教育/培训/科研": {
      "code": '教育/培训/科研',
      "name": '教育/培训/科研',
      "children": {
        '教育': '教育',
        '科研': '科研',
        '培训': '培训',

      },
    },
    "文化/传媒/出版/印刷": {
      "code": '文化/传媒/出版/印刷',
      "name": '文化/传媒/出版/印刷',
      "children": {
        '文化传播': '文化传播',
        '影视': '影视',
        '出版印刷': '出版印刷',
      },
    },
    "旅游/酒店/餐饮": {
      "code": '旅游/酒店/餐饮',
      "name": '旅游/酒店/餐饮',
      "children": {
        '酒店': '酒店',
        '餐饮': '餐饮',
        '旅游': '旅游',

      },
    },
    "服务/中介/物业": {
      "code": '服务/中介/物业',
      "name": '服务/中介/物业',
      "children": {
        '服务': '服务',
        '物业': '物业',
        '中介': '中介',
      },
    },
    "消费品": {
      "code": '消费品',
      "name": '消费品',
      "children": {
        '耐用消费品': '耐用消费品',
        '快速消费品': '快速消费品',
      },
    },
    "生物/医药/保健": {
      "code": '生物/医药/保健',
      "name": '生物/医药/保健',
      "children": {
        '制药': '制药',
        '生物': '生物',
        '医疗': '医疗',
        '卫生服务': '卫生服务',
        '保健': '保健',
      },
    },
    "电子/微电子": {
      "code": '电子/微电子',
      "name": '电子/微电子',
      "children": {
        '半导体': '半导体',
        '仪器仪表': '仪器仪表',
        '电子技术': '电子技术',
      },
    },
    "电气/电力": {
      "code": '电气/电力',
      "name": '电气/电力',
      "children": {
        '电气/电力': '电气/电力',
      },
    },
    "石油/化工/能源": {
      "code": '石油/化工/能源',
      "name": '石油/化工/能源',
      "children": {
        '石油': '石油',
        '其他能源': '其他能源',
        '化工': '化工',
        '地质矿产': '地质矿产',
      },
    },
    "艺术/休闲/运动": {
      "code": '艺术/休闲/运动',
      "name": '艺术/休闲/运动',
      "children": {
        '休闲': '休闲',
        '艺术': '艺术',
      },
    },
    "贸易/进出口/零售批发": {
      "code": '贸易/进出口/零售批发',
      "name": '贸易/进出口/零售批发',
      "children": {
        '进出口': '进出口',
        '零售批发': '零售批发',
        '贸易': '贸易',
      },
    },
    "通用类": {
      "code": '通用类',
      "name": '通用类',
      "children": {
        '人力资源管理': '人力资源管理',
        '其他通用': '其他通用',
        '行政管理·行政事务': '行政管理·行政事务',
        '销售': '销售',
      },
    },
    "通讯": {
      "code": '通讯',
      "name": '通讯',
      "children": {
        '通讯': '通讯',
      },
    },
    "金融/银行": {
      "code": '金融/银行',
      "name": '金融/银行',
      "children": {
        '银行': '银行',
        '证券·基金': '证券·基金',
        '保险': '保险',
        '投资': '投资',
      },
    }
  }
  if (type == null) {
    return list;
  } else {
    return list[type]
  }

}



// WEBPACK FOOTER //
// ./src/libs/tools.js